"use client";

import * as React from "react";
import type { ClassNameValue } from "tailwind-merge";
import { InputInfo } from "./InputInfo";
import { Label } from "./Label";
import { cn } from "@repo/shared/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  id: string;
  containerClassName?: ClassNameValue;
  error?: boolean;
  errorMessage?: string;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { label, className, containerClassName, error, errorMessage, ...props },
    ref
  ) => {
    return (
      <div className={cn("flex flex-col gap-y-3", containerClassName)}>
        {label && <Label label={label} id={props.id} />}

        <textarea
          className={cn(
            "flex min-h-[80px] w-full rounded-md border border-input bg-white px-3 py-2 text-sm ring-offset-background text-form-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          ref={ref}
          {...props}
        />
        {error && errorMessage && <InputInfo info={errorMessage} />}
      </div>
    );
  }
);

TextArea.displayName = "Textarea";

export { TextArea };
